import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { fetchDepts } from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddCompanySectionModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { depts, loading } = useSelector((state) => state.dropdown);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.coDeptid) {
      toast.error("Please select a department");
      return;
    }
    const res = await dispatch(
      save({
        coSectionid: prodd?.coSectionid ? prodd?.coSectionid : null,
        coDeptid: formData?.coDeptid,
        coSectioncode: formData?.coSectioncode,
        coSectionname: formData?.coSectionname,
        url: "hr/saveSections.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchDeptsData(page, size) {
    dispatch(fetchDepts());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd ? `Edit section ${prodd?.coSectionname}` : "Add section details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label={<span>Department</span>}
            rules={[
              {
                required: true,
                message: "Please select department",
              },
            ]}
          >
            <Select
              name="coDeptid"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                depts?.length > 0 &&
                depts?.map((item) => ({
                  value: item?.coDeptid,
                  label: item?.coDeptname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "coDeptid");
              }}
              value={formData?.coDeptname}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchDeptsData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Section Code"
            rules={[
              {
                required: true,
                message: "Enter section Code",
              },
            ]}
          >
            <Input
              readOnly={prodd?.coSectionid ? true : false}
              required
              name="coSectioncode"
              onChange={onChange}
              value={formData?.coSectioncode}
              className="input"
            />
          </Form.Item>
          <Form.Item
            label="Section Name"
            rules={[
              {
                required: true,
                message: "Enter section name",
              },
            ]}
          >
            <Input
              required
              name="coSectionname"
              onChange={onChange}
              value={formData?.coSectionname}
              className="input"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddCompanySectionModal;
